export const generateId = (length = 10, letterPrefixLength = 3): string => {
  const letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const alphanum =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

  const getRandomChar = (chars: string) =>
    chars[Math.floor(Math.random() * chars.length)]

  let id = ''

  // First few characters must be letters
  for (let i = 0; i < letterPrefixLength; i++) {
    id += getRandomChar(letters)
  }

  // Remaining characters can be alphanumeric
  for (let i = letterPrefixLength; i < length; i++) {
    id += getRandomChar(alphanum)
  }

  return id
}

export const exportStyleFromClassName = (className: string) => {
  const pattern = /(top-|left-|bottom-|right-)([^\s]+)/g
  const obj: Partial<Record<'top' | 'left' | 'bottom' | 'right', string>> = {}
  className.replace(
    pattern,
    function (substring, positionEle: string, positionValue: string) {
      const key: keyof typeof obj = positionEle.replace(
        '-',
        ''
      ) as keyof typeof obj
      obj[key] = positionValue.replace(/[\[\]]/g, '').replaceAll('_', ' ')
      return substring
    }
  )
  return obj
}
